import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import { PROMOCODE_LIST, DELETE_PROMOCODE, GET_PROMOCODE_STATS_API } from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
} from "../../../utilities/const";
import { Link, useLocation } from "react-router-dom";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";
import CouponStats from "../../../components/Common/CouponStat";
import HotelAdminFilter from "../../../components/Common/HotelAdminFilter";
import { useTranslation } from "react-i18next";

const Promocode = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;

  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: PROMOCODE_LIST,
  });


  const {
    // setBody,
    // statusChangeHandler,
    // body,
    data: dataPromocodeStats,
    // loader,
    // deleteModel,
    // setDeleteModel,
    // setCommisionModel,
    // paginationHandler,
    // searchHandler,
    // total,
    // deleteHandler,
  } = dataHandler({
    api: GET_PROMOCODE_STATS_API,
  });

  // console.log(`dataPromocodeStats`, dataPromocodeStats)
  const column = [
    {
      head: t("coupon.table.srNo"),
      accessor: "#",
      component: (item, key) => <>{body.limit * (body.page - 1) + key + 1}</>,
    },
    {
      head: t("coupon.table.couponName"),
      accessor: "name",
      component: (item) => (
        <span
          title={item?.name}
          className="text-truncate d-inline-block"
          style={{ maxWidth: 150 }}
        >
          {item?.name || "-"}
        </span>
      ),
    },
    {
      head: t("coupon.table.couponCode"),
      accessor: "promocode",
      component: (item) => (
        <span
          title={item?.promocode}
          className="text-truncate d-inline-block"
          style={{ maxWidth: 120 }}
        >
          {item?.promocode || "-"}
        </span>
      ),
    },
    {
      head: t("coupon.table.discountType"),
      accessor: "type",
      component: (item) => (
        <span className="text-capitalize">{item?.type || "-"}</span>
      ),
    },
    {
      head: t("coupon.table.amount"),
      accessor: "amount",
      component: (item) => <span>{item?.value ?? item?.value ?? "-"}</span>,
    },
    {
      head: t("coupon.table.usedCount"),
      accessor: "usedCount",
      component: (item) => <span>{item?.usedCount ?? 0}</span>,
    },
    {
      head: t("coupon.table.startDate"),
      accessor: "startDate",
      component: (item) => (
        <span>
          {item?.startDate
            ? moment.utc(item.startDate).local().format("DD-MM-YYYY hh:mm A")
            : "-"}
        </span>
      ),
    },
    {
      head: t("coupon.table.expireDate"),
      accessor: "endDate",
      component: (item) => (
        <span>
          {item?.endDate
            ? moment.utc(item.endDate).local().format("DD-MM-YYYY hh:mm A")
            : "-"}
        </span>
      ),
    },
    {
      head: t("coupon.table.status"),
      accessor: "status",
      component: (item) => {
        const status = (item?.status || "").toLowerCase();
        let badgeClass = "";

        switch (status) {
          case "active":
            badgeClass = "badge bg-success";
            break;
          case "inactive":
            badgeClass = "badge bg-secondary";
            break;
          case "closed":
            badgeClass = "badge bg-danger";
            break;
          case "open":
            badgeClass = "badge bg-info";
            break;
          default:
            badgeClass = "badge bg-light text-dark";
        }

        return (
          <span className={badgeClass} style={{ textTransform: "capitalize" }}>
            {t(`coupon.status.${status}`)}
          </span>
        );
      },
    },
    {
      head: t("coupon.table.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          editUrl={`/promoCode/edit/${item._id}?page=${body.page}`}
          viewLink={`/promoCode/detail/${item._id}?page=${body.page}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item?._id })
          }
        />
      ),
    },
  ];
  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => DELETE_PROMOCODE({ _id: deleteModel.dumpId }))
        }
      />
      <section className="promocode  position-relative">
        <Container>
          <Row>
            <Col
              lg="12"
              className="d-flex justify-content-between align-items-center"
            >
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("coupon.title")}
              </h4>

              <div className="right">
                <Link
                  to="/promocode/add"
                  className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn"
                  style={{ height: 40, minWidth: 100, fontSize: 12 }}
                >
                  {t("coupon.addNew")}
                </Link>
              </div>
            </Col>

            {/* <Col lg="12" className="loyalityprogram_section">
              <div
                className="loyalityprogram  p-3 d-flex align-items-center justify-content-between 
              gap-3"
              >
                <div className="loyalityprogram_left">
                  <h6 className="m-0 fw-bold">
                    <span className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        data-lucide="shield-check"
                        class="lucide lucide-shield-check w-6 h-6 text-indigo-600 mr-3"
                      >
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                    </span>
                    Loyalty Program Status :
                    <span className="spanstatus">
                      {" "}
                      Active (X+1 Rules Applied)
                    </span>
                  </h6>
                </div>
                <div className="loyalityprogram_right">
                  <button className="deactivatebtn fw-bold">
                    Deactivate Program
                  </button>
                </div>
              </div>
            </Col> */}

            <Col lg="12" className="">
              <CouponStats dashboardData={dataPromocodeStats} />
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <HotelAdminFilter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                    type="coupon"
                  />
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Promocode;
